export default "__VITE_ASSET__rqEedl$5__"